export const DUPLICATE_ITEM = 'DUPLICATE_ITEM';

export const duplicateItem = ({ id, context }) => ({
  type: DUPLICATE_ITEM,
  id,
  context,
});
